<template>
<div class="chapter">
<div class="inner_page">
<p class="p8"><span class="t6"><b>Dedication</b></span></p>
<p class="p0">To my family, my friends, and my readers.</p>
<p class="p0">Your support makes it all possible.</p>
<p> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?152e48e7